import Router from "./Router";
import React from "react";
import "./styles/App.css";
import "./styles/Basic.css";

export default function App() {
    return (
        <>
            <Router />
        </>
    );
}
